export const IconSavedFromCvBase: {
  name: 'icon_saved_from_cv_base-b978ebe8e2ba'
} = {
  name: 'icon_saved_from_cv_base-b978ebe8e2ba'
}
